module.exports = __webpack_public_path__ + "static/media/calendar-date-schedule-svgrepo-com.7707bf2b.svg";